module.exports = __webpack_public_path__ + "img/ILEK_120X35.8b983ded.png";